import { OnInit } from '@angular/core';
import { Directive, ElementRef, Input } from '@angular/core';
import { AuthorizationService } from '../services/authorization.service';

@Directive({
    selector: '[isHideIfUnauthorized]',
    standalone: false
})
export class HideIfUnauthorizedDirective implements OnInit {
	@Input('isHideIfUnauthorized') role!: string;

	constructor(private el: ElementRef, private authorizationService: AuthorizationService) {}

	ngOnInit() {
		this.authorizationService.inRole(this.role).then(result => {
			if (!result) {
				this.el.nativeElement.style.display = 'none';
			}
		});
	}
}
